import { RouteRecordRaw } from 'vue-router';
import { OFooter } from 'ofe-common/components';
import SimpleNavbar from '@globals/components/navigation/SimpleNavbar.vue';

export default [
	{
		path: '/konto/onboarding',
		name: 'CustomerOnboarding',
		components: {
			default: () => import('@customer/onboarding/OnboardingView.vue'),
			navbar: SimpleNavbar,
			footer: OFooter,
		},
		children: [
			{
				path: 'witaj',
				name: 'CustomerOnboardingWelcome',
				component: () => import('@customer/onboarding/OnboardingWelcome.vue'),
				meta: {
					hideSidebar: true,
				},
			},
			{
				path: 'informacje',
				name: 'CustomerOnboardingBasicInfo',
				component: () => import('@customer/profile/BasicInfoPage.vue'),
				meta: {
					hidePreviousStepButton: true,
				},
			},
			{
				path: 'dane-kontaktowe',
				name: 'CustomerOnboardingContactInfo',
				component: () => import('@customer/profile/ContactInfoPage.vue'),
			},
			{
				path: 'opis',
				name: 'CustomerOnboardingDescription',
				component: () => import('@customer/profile/DescriptionPage.vue'),
			},
			{
				path: 'galeria-zdjec',
				name: 'CustomerOnboardingGallery',
				component: () => import('@customer/profile/GalleryPage.vue'),
			},
			{
				path: 'weryfikacja-telefonu',
				name: 'CustomerOnboardingPhoneVerification',
				component: () => import('@customer/profile/PhoneVerificationPage.vue'),
			},
		],
	},
	{
		path: '/konto/onboarding/:catchAll(.*)',
		redirect: '/konto/onboarding',
	},
] as RouteRecordRaw[];
